"use client";

import Link from "next/link";

import type { OverlayMenuBaseProps } from "@/app/components/menu/overlayMenuSystem";
import styles from "./valuePropsSection.module.scss";

export const MONEY_BACK_GUARANTEE_TITLE = "Net32 Money Back Guarantee";

const RETURN_POLICY_URL =
  "https://support.net32.com/hc/en-us/articles/28136939501203-Is-my-product-eligible-for-a-return";
const SHIPPING_POLICY_URL =
  "https://support.net32.com/hc/en-us/articles/41919340147987-How-Does-Shipping-Work-on-Net32";

export default function MoneyBackGuaranteeMenu({ closeCallback }: OverlayMenuBaseProps) {
  return (
    <div className={styles.guaranteeDetails} data-money-back-guarantee-drawer>
      <div className={styles.guarantee}>
        <p className={styles.guaranteeLead}>
          If you&apos;re not happy with your purchase, Net32 will fully reimburse you under our 30 Day Unconditional
          Money Back Guarantee.
        </p>
        <div className={styles.guaranteeBody}>
          <p>
            Net32 works with trusted vendors, manufacturers, and distributors to help provide reliable products,
            responsive service, and a better purchasing experience.
          </p>
          <p>
            If a product does not meet expectations and is not covered by a manufacturer or vendor guarantee, Net32 will
            help make it right. We may provide a prepaid return label and arrange a replacement or reimbursement, based
            on the issue and eligibility.
          </p>
          <p>
            No additional return shipping charges apply when the return is approved under the Net32 30-Day Money-Back
            Guarantee.
          </p>
        </div>
      </div>
      <div className={styles.policies}>
        <h3 className={styles.policiesTitle}>Return Policy &amp; Shipping Policy</h3>
        <p className={styles.policiesText}>
          Each Net32 vendor has their own specific return policy and shipping criteria, cataloged on our{" "}
          <Link
            href="/vendor"
            prefetch={false}
            className={styles.link}
            onClick={closeCallback}
            data-money-back-guarantee-link="vendor-list"
          >
            Vendor List
          </Link>{" "}
          page. For general information, refer to the{" "}
          <a
            href={RETURN_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
            data-money-back-guarantee-link="return-policy"
          >
            Return Policy
          </a>{" "}
          or the{" "}
          <a
            href={SHIPPING_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
            data-money-back-guarantee-link="how-shipping-works"
          >
            How Shipping Works
          </a>{" "}
          pages.
        </p>
      </div>
    </div>
  );
}
